import { Controller } from "stimulus";
import $ from 'jquery';

export default class extends Controller {
  submit(e) {
    e.preventDefault();

    const submitPath = this.element.action;

    $.ajax({
      type: "post",
      url: submitPath,
      dataType: "json",
      data: $(this.element).serialize()
    }).then(
      data => {
        this.element.reset();
      },
      error => {
        toastr.error("メッセージの送信に失敗しました");
      }
    )
  }
}
